module.exports = __webpack_public_path__ + "static/media/faq-checklist.12275963.svg";